import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";
import { MapPin, Phone, Clock } from "lucide-react";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <PageHero
        eyebrow="Get a Quote"
        title="Tell us about your move"
        subtitle="Share a few details and a relocation specialist will respond within one business day."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid lg:grid-cols-3 gap-12">
          <Reveal className="lg:col-span-2 bg-white border border-slate-200 rounded-md p-7 sm:p-10">
            <QuoteForm />
          </Reveal>
          <Reveal delay={0.15} className="space-y-6">
            <div className="bg-navy text-white rounded-md p-8">
              <h3 className="font-display font-bold text-xl mb-6">Headquarters</h3>
              <p className="flex items-start gap-3 text-sm text-white/70 mb-5">
                <MapPin size={17} className="text-brand mt-0.5 shrink-0" />
                23710 Schooler Plaza #87,<br />Ashburn VA 20148
              </p>
              <a href="tel:+15718509694" data-testid="contact-phone-link"
                className="flex items-center gap-3 text-sm text-white/70 hover:text-brand transition-colors mb-5">
                <Phone size={17} className="text-brand shrink-0" /> (571) 850-9694
              </a>
              <p className="flex items-start gap-3 text-sm text-white/70">
                <Clock size={17} className="text-brand mt-0.5 shrink-0" />
                Monday – Friday, 8:00 AM – 6:00 PM<br />Weekend moves by appointment
              </p>
            </div>
            <div className="bg-brand-subtle border border-brand/20 rounded-md p-8">
              <h3 className="font-display font-bold text-lg text-navy mb-3">What happens next?</h3>
              <ol className="space-y-3 text-sm text-slate-600 list-decimal list-inside">
                <li>A specialist reviews your scope within one business day.</li>
                <li>We schedule a walkthrough or virtual survey.</li>
                <li>You receive one transparent, fixed proposal.</li>
              </ol>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
